import { CHANGE_APP_PROPS } from "../actions/ActionConstants";

const initialState = {
	firstTimeFlag: false,
	loading: false,
	loadingText: "Cargando...",
	login: false, //cambiar esto a false
	username: "",
	rol: "", //cambiar esto a vacío
	active: false,
	confirmEmail: false,
	firebaseToken: "",
	permissions: {
		countries: "",
		benefit: "",
		products: ""
	}
};

export default function(state = initialState, action) {
	if (action.type === CHANGE_APP_PROPS) {
		return Object.assign({}, state, action.props);
	}
	return state;
}



// WEBPACK FOOTER //
// ./src/reducers/AppReducer.js